import React from 'react';
import classNames from 'classnames';
import Heading from '../Heading';
import './styles.css';

const DropDown = ({ children, heading, show }) => {
  return (
    <div
      className={classNames('Listview__Filters__DropDown__root', {
        'Listview__Filters__DropDown__root--show': show,
      })}
    >
      <Heading>{heading}</Heading>
      {children}
    </div>
  );
};

export default DropDown;
